import { DISABLED } from '../config/constants';

const addToCart = async (button, variant, relatedProduct, relatedProductId = null) => {
  console.info('addToCart', button, variant, relatedProduct, relatedProductId);
  button.setAttribute(DISABLED, DISABLED);
  const items = [
    {
      quantity: 1,
      id: variant.id,
    },
  ];
  if (relatedProductId) {
    items.push({ quantity: 1, id: relatedProductId, properties: { addOn: true } });
  } else if (relatedProduct) {
    const select = relatedProduct.querySelector('select');
    const parts = select.value.split('/');
    const relatedId = parseInt(parts[parts.length - 1], 10);
    const option = relatedProduct.querySelector(`select option[value="${select.value}"]`);

    if (parseInt(option.dataset.price, 10) > 0) {
      items.push({ quantity: 1, id: relatedId, properties: { addOn: true } });
    }
  }

  const request = await fetch('/cart/add.js', {
    body: JSON.stringify({ items }),
    credentials: 'include',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });
  try {
    const response = await request.json();
    if (request.ok) {
      // window.location.assign('/cart');
      const event = new CustomEvent('add-to-cart', { detail: { items } });
      window.dispatchEvent(event);
    } else {
      alert(`We had a problem adding that to your cart. \n${response.description}`);
    }
  } catch (err) {
    console.error(err);
  }
  button.removeAttribute(DISABLED);
};
export default addToCart;
